import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UniqueNameValidation } from 'src/app/Modules/management/core/Validators/unique-name.validator';
import { DbSelectLookUpModel, DbSelectLookUpValue } from 'src/app/Modules/settings/models/idms/db-select-look-up.model';

@Component({
    selector: 'app-add-update-db-look-up-field',
    templateUrl: './add-update-db-look-up-field.component.html',
    styleUrls: ['./add-update-db-look-up-field.component.scss'],
    standalone: false
})
export class AddUpdateDBLookUpFieldComponent implements OnInit {
    @Input() modalMode: string;
    @Input() dbSelectLookUpItem: DbSelectLookUpModel;
    @Input() dbSelectLookUpItemList: DbSelectLookUpModel[];

    newLookUpFieldArray: UntypedFormArray;
    editLookUpForm: UntypedFormGroup;
    fieldsNameList: string[];
    valuesList: string[];
    counter = 0;

    constructor(
        public ngbActiveModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder
    ) {
        this.valuesList = [];
    }

    ngOnInit(): void {
        if (this.modalMode == 'add') {
            this.newLookUpFieldArray = this.formBuilder.array([this.dbLookUpFiledHandler(2)]);
            this.newLookUpFieldArray.valueChanges.subscribe((res) => {
                if (res) {
                    this.formValidationHandler();
                }
            });
        } else if (this.modalMode == 'edit') {
            this.fieldsNameList = this.dbSelectLookUpItemList.map((item) => item.name);
            this.fieldsNameList = this.fieldsNameList.filter((item) => item.toLowerCase().trim() != this.dbSelectLookUpItem.name.toLowerCase().trim());
            let lookUpField = this.dbSelectLookUpItemList.find((item) => item.name.toLowerCase().trim() == this.dbSelectLookUpItem.name.toLowerCase().trim());
            this.valuesList = lookUpField.values.map((value) => value.name);
            this.valuesList = this.valuesList.filter((value) => value.toLowerCase().trim() !== this.dbSelectLookUpItem.values[0].name.toLowerCase().trim());
            this.dbLookUpFiledHandler(3);
        }
    }

    // * modal event handler
    dbLookUpFiledHandler(index: number, removeIndex?: number) {
        switch (index) {
            // * add new field
            case 0:
                this.newLookUpFieldArray.push(this.dbLookUpFiledHandler(2));
                break;

            // * remove field
            case 1:
                this.newLookUpFieldArray.removeAt(removeIndex);
                break;

            // * create form group
            case 2:
                return new UntypedFormGroup({
                    controlNumber: new UntypedFormControl(++this.counter, []),
                    key: new UntypedFormControl('', [Validators.required]),
                    value: new UntypedFormControl('', [Validators.required]),
                });

            // * create edit form group
            case 3:
                this.editLookUpForm = this.formBuilder.group({
                    dbSelectName: new UntypedFormControl(this.dbSelectLookUpItem.name, [Validators.required]),
                    dbSelectValueName: new UntypedFormControl(this.dbSelectLookUpItem.values[0].name, [
                        Validators.required,
                        UniqueNameValidation(this.valuesList),
                    ]),
                });
                break;
        }
    }

    // * handle form validations
    formValidationHandler(): void {
        this.newLookUpFieldArray.controls.forEach((control, pos) => {
            const keyIndex = this.dbSelectLookUpItemList.findIndex((item) => {
                if (item.name.toLowerCase().trim() == control.value.key.toLowerCase().trim()) {
                    return true;
                }
                return false;
            });
            if (keyIndex !== -1) {
                let valuesList = this.dbSelectLookUpItemList[keyIndex].values.map((value) => value.name);
                let existingControlWithSameKey = this.newLookUpFieldArray.controls.filter(
                    (fcontrol, findex) =>
                        fcontrol.value.key.trim().toLowerCase() == control.value.key.trim().toLowerCase() &&
                        control.value.controlNumber !== fcontrol.value.controlNumber
                );
                existingControlWithSameKey.forEach((item) => {
                    valuesList.push(item.value.value);
                });
                if (this.compareValues(valuesList, control.value.value)) {
                    control.get('value').setErrors({ alreadyExistInList: true });
                } else {
                    control.get('value').setErrors(null);
                    if (!control.get('value').value) control.get('value').setErrors({ required: true });
                }
            } else {
                // * key is not exist in our database
                let existingControlWithSameKey = this.newLookUpFieldArray.controls.filter(
                    (fcontrol, findex) =>
                        fcontrol.value.key.trim().toLowerCase() == control.value.key.trim().toLowerCase() &&
                        control.value.controlNumber !== fcontrol.value.controlNumber
                );
                let valuesList = [];
                existingControlWithSameKey.forEach((item) => {
                    valuesList.push(item.value.value);
                });
                if (this.compareValues(valuesList, control.value.value)) {
                    control.get('value').setErrors({ alreadyExistInList: true });
                } else {
                    control.get('value').setErrors(null);
                    if (!control.get('value').value) control.get('value').setErrors({ required: true });
                }
            }
        });
    }

    compareValues(namesList: string[], targetValue: string): boolean {
        return namesList.find((name) => name.toLowerCase().trim() === targetValue.toLowerCase().trim()) ? true : false;
    }

    // * helper method to save the data
    saveModalData() {
        if (this.modalMode == 'add') {
            const values: {
                key: string;
                value: string;
            }[] = this.newLookUpFieldArray.value;
            let namesList = [];
            values.forEach((item) => {
                namesList = [...namesList, item.key];
            });
            namesList = [...new Set(namesList)];
            let dbLookUpField: DbSelectLookUpModel[] = [];

            namesList.forEach((item) => {
                let childItems = this.newLookUpFieldArray.value.filter((controlValue) => controlValue.key == item);
                // * generating DB look up object
                const dbLookUpFieldObj = new DbSelectLookUpModel();
                dbLookUpFieldObj.name = item;
                dbLookUpFieldObj.values = [];
                childItems.forEach((item) => {
                    const dbLookUpFieldValueObj = new DbSelectLookUpValue();
                    dbLookUpFieldValueObj.name = item.value;
                    dbLookUpFieldObj.values = [...dbLookUpFieldObj.values, dbLookUpFieldValueObj];
                });
                dbLookUpField = [...dbLookUpField, dbLookUpFieldObj];
            });

            this.ngbActiveModal.close(dbLookUpField);
        } else if (this.modalMode == 'edit') {
            this.ngbActiveModal.close(this.editLookUpForm.value);
        }
    }

    closeClick() {
        this.ngbActiveModal.close();
    }
}
